import React from 'react'
import {
  Input,
  FormGroup
} from 'reactstrap'

const CostCenterNetworkFilters = ({ onChangeFilter }) => {
  return (
    <tr>
      <td>
        <FormGroup>
          <Input
            type='text'
            name='Identifier'
            id='by_identifier'
            placeholder='Identifier'
            onChange={onChangeFilter}
          />
        </FormGroup>
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  )
}

export default CostCenterNetworkFilters